export enum ReauthErrorKind {
  WrongPassword = 'wrong-password',
  // The re-authentication credential belongs to a different account than the
  // one currently signed in. This is the guard against deleting the wrong
  // account by signing in as someone else.
  UserMismatch = 'user-mismatch',
  Cancelled = 'cancelled',
  NoUser = 'no-user',
  Unknown = 'unknown',
}

export class ReauthError extends Error {
  constructor(
    public readonly kind: ReauthErrorKind,
    options?: ErrorOptions,
  ) {
    super(`Re-authentication failed: ${kind}`, options);
    this.name = 'ReauthError';
  }
}
